(() => {
  function initDescriptionUpdater() {
    if (!window.eventBus) {
      setTimeout(initDescriptionUpdater, 100);
      return;
    }

    const section = document.querySelector('.section--product-description[data-section-id]');
    if (!section) return;

    const sectionId = section.dataset.sectionId;
    const productUrl = section.dataset.productUrl;
    if (!sectionId || !productUrl) return;

    let updateCache = new Map();

    async function updateDescriptionSection(variant) {
      if (!variant) return;

      const productInformation = document.querySelector('product-information');
      if (!productInformation) return;

      const selectedOptions = Array.from(
        productInformation.querySelectorAll('li[data-product-variant][selected], input[data-product-variant]:checked')
      ).map(el => el.dataset.optionValueId).filter(Boolean);

      if (!selectedOptions.length) return;

      const params = [`section_id=${sectionId}`, `option_values=${selectedOptions.join(',')}`];
      const fetchUrl = `${productUrl}?${params.join('&')}`;

      if (updateCache.has(fetchUrl) && !window.Shopify.designMode) {
        updateSectionContent(updateCache.get(fetchUrl));
        return;
      }

      try {
        const response = await fetch(fetchUrl);
        if (!response.ok) return;

        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector(`.section--product-description[data-section-id="${sectionId}"]`);

        if (!newSection) return;

        updateCache.set(fetchUrl, newSection);
        updateSectionContent(newSection);
      } catch (error) {
        console.error('Failed to update product description section:', error);
      }
    }

    function updateSectionContent(newSection) {
      const currentElements = Array.from(section.querySelectorAll('[data-update-id]'));

      currentElements.forEach(currentElement => {
        const updateId = currentElement.getAttribute('data-update-id');
        const newElement = newSection.querySelector(`[data-update-id="${updateId}"]`);

        if (newElement) {
          const clonedElement = newElement.cloneNode(true);
          currentElement.replaceWith(clonedElement);
        }
      });
    }

    window.eventBus.on('variant:updated', (event) => {
      const variant = event?.variant || event?.detail?.variant;
      if (variant) {
        updateDescriptionSection(variant);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDescriptionUpdater);
  } else {
    initDescriptionUpdater();
  }
})();

